<script>

export default {
  name: "PaymentFailures",
  data () {
    return {
      code: null,
    }
  },
  created() {
    this.code = this.$route.params.code;
  },
  methods: {
    moveToCart () {
      this.$router.replace({ name: 'CartsIndex' })
    },
  },

}
</script>

<template>
  <v-container>
    <div v-if="Number(code) === 40201" class="failure_container">
      <div>
        <h1 class="text-center">
          決済に失敗しました。
        </h1>
        <h3 class="text-center mt-5">
          会員情報のお支払い方法より<br />
          クレジットカードの有効期限またはセキュリティーコードをご確認いただき、<br />
          再度注文確定を実施してください。
        </h3>
        <h5 class="text-center ma-2 lang_lbl">{{ $t('view.3d_secure_incomplete') }}</h5>
      </div>
    </div>
    <div v-else class="failure_container">
      <div>
        <h1 class="text-center">
          注文確定で処理エラーが発生しました。<br />
        </h1>
        <h3 class="text-center mt-5">
          大変お手数ですが、一度お申し込み情報に戻り、<br />
          再度注文確定を実施してください。
        </h3>
        <h5 class="text-center ma-2 lang_lbl">{{ $t('view.3d_secure_incomplete') }}</h5>
      </div>
    </div>
  </v-container>
</template>

<style scoped lang="scss">

</style>